module.exports = {
    code2mode: {
        "GPOCR0001": 'OCR',
        "DEEPOCR01": 'Deep OCR',
        "TMPLTM01": 'Fixed format',
        "GS0000001": 'Storage'
    }
}